import { combineReducers } from 'redux';
import omit from 'lodash/omit';

import * as types from '../types';

const byId = (state: any = {}, action: any) => {
  switch (action.type) {
    case types.DISTRIBUTION_CHANNELS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState: any = {};
      order.forEach((id: any) => {
        newState[id] = { ...entities[id] };
      });
      return newState;
    }
    case types.DISTRIBUTION_CHANNEL_SAVE_COMPLETED: {
      const { distributionChannel } = action.payload;
      return {
        ...state,
        [distributionChannel.distributionChannelId]: { ...distributionChannel }
      };
    }
    case types.DISTRIBUTION_CHANNEL_DELETE_COMPLETED: {
      return omit(state, action.payload.distributionChannelId);
    }
    default:
      return state;
  }
};

const allIds = (state: number[] = [], action: any) => {
  switch (action.type) {
    case types.DISTRIBUTION_CHANNELS_FETCH_COMPLETED:
      return [...action.payload.order];
    case types.DISTRIBUTION_CHANNEL_SAVE_COMPLETED: {
      const { distributionChannelId } = action.payload.distributionChannel;
      return state.includes(distributionChannelId) ? state : [...state, distributionChannelId];
    }
    case types.DISTRIBUTION_CHANNEL_DELETE_COMPLETED:
      return state.filter((id) => id !== action.payload.distributionChannelId);
    default:
      return state;
  }
};

const isLoading = (state = false, action: any) => {
  switch (action.type) {
    case types.DISTRIBUTION_CHANNELS_FETCH_STARTED:
      return true;
    case types.DISTRIBUTION_CHANNELS_FETCH_COMPLETED:
    case types.DISTRIBUTION_CHANNELS_FETCH_FAILED:
      return false;
    default:
      return state;
  }
};

const error = (state: any = null, action: any) => {
  switch (action.type) {
    case types.DISTRIBUTION_CHANNELS_FETCH_FAILED:
    case types.DISTRIBUTION_CHANNEL_SAVE_FAILED:
    case types.DISTRIBUTION_CHANNEL_DELETE_FAILED:
      return action.payload.error;
    default:
      return state;
  }
};

const distributionChannelsReducer = combineReducers({ byId, allIds, isLoading, error });

export default distributionChannelsReducer;

/* -------------------------------- SELECTORS ------------------------------- */
const getSlice = (state: any) => state.distributionChannels;

export const getDistributionChannels = (state: any) => {
  const slice = getSlice(state);
  return slice.allIds.map((id: number) => slice.byId[id]);
};

export const getDistributionChannel = (state: any, id: number) => getSlice(state).byId[id];

export const getIsLoadingDistributionChannels = (state: any) => getSlice(state).isLoading;
